import BottomSheet, { BottomSheetBackdrop, useBottomSheetDynamicSnapPoints } from '@gorhom/bottom-sheet';
import { SafeAreaView, ScrollView, SxProp, View } from 'dripsy';
import { useNavigation } from '@react-navigation/native';
import React, { useCallback, useContext, useRef } from 'react';

import { DevToolsStackRoutes, DevToolsStackScreenProps } from '../types';
import { UniButton } from '@/design-system/components/buttons';
import { BottomSheetHeader } from '@/design-system/components/headers';
import { H6 } from '@/design-system/components/typography';
import { LayoutContext } from 'contexts/LayoutContext';

export const DevToolsBottomSheet: React.FC<DevToolsStackScreenProps<DevToolsStackRoutes.BottomSheet>> = ({ navigation }) => {
  const bottomSheetRef = useRef<BottomSheet>(null);
  return (
    <SafeAreaView sx={styles.container}>
      <Body bottomSheetRef={bottomSheetRef} onBack={() => navigation.goBack()} />
    </SafeAreaView>
  );
};

const Body = ({ bottomSheetRef, onBack }: { bottomSheetRef: React.RefObject<BottomSheet>; onBack: () => void }) => {
  const layout = useContext(LayoutContext);

  const renderBackdrop = useCallback(
    (props) => <BottomSheetBackdrop {...props} disappearsOnIndex={0} appearsOnIndex={1} pressBehavior={'none'} enableTouchThrough={true} />,
    []
  );
  const { width: layoutWidth, height } = layout.dimensions;
  const width = layoutWidth / 0.9;
  const { animatedHandleHeight, animatedSnapPoints, animatedContentHeight, handleContentLayout } = useBottomSheetDynamicSnapPoints([
    'CONTENT_HEIGHT',
    'CONTENT_HEIGHT'
  ]);
  // Bottom Sheet on mobile
  return (
    <View sx={{ width, height, backgroundColor: 'transparent' }}>
      <BottomSheet
        index={1}
        ref={bottomSheetRef}
        snapPoints={animatedSnapPoints}
        handleHeight={animatedHandleHeight}
        contentHeight={animatedContentHeight}
        backdropComponent={renderBackdrop}
        handleComponent={() => (
          <View
            sx={{ height: '$5', borderTopLeftRadius: 10, borderTopRightRadius: 10, backgroundColor: '$backgroundPrimary', borderWidth: 0 }}
          />
        )}>
        <View sx={{ height: 'auto', width, backgroundColor: '$backgroundPrimary' }} onLayout={handleContentLayout}>
          <BottomSheetHeader
            title="BottomSheet Header"
            onPress={() => {
              bottomSheetRef.current?.close();
              onBack();
            }}
            sx={{ paddingX: '$4', pb: 0 }}
          />
          <View sx={{ padding: '$4', gap: '$4' }}>
            <H6>This is BottomSheet Body.</H6>
          </View>
          <UniButton
            size="default"
            onPress={() => {
              bottomSheetRef.current?.close();
              onBack();
            }}
            label="Go Back"
            wrapperSx={{ flex: 1, marginX: '$4', mb: '$4' }}
            loading={false}
          />
        </View>
      </BottomSheet>
    </View>
  );
};

enum StyleName {
  container = 'container',
  pageItem = 'pageItem'
}

const styles: Record<StyleName, SxProp> = {
  container: {},
  pageItem: {}
};
